module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "showSmallScreenOnly",
    class: _vm.colorBottomButton
  }, [_c('f7-fab', {
    staticClass: "leftfav3 bottomButton floatingButtonToolbarBlank",
    on: {
      "click": _vm.sendAllReadyPayments
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "sort_down_round_fill"
    }
  })], 1), _vm._v(" "), _c('f7-fab', {
    staticClass: "leftfav2 button-fab bottomButton floatingButtonToolbarBlank",
    on: {
      "click": _vm.createDraft
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "edit"
    }
  })], 1), _vm._v(" "), (_vm.draftsSelected.length > 0) ? _c('f7-fab', {
    staticClass: "leftfav bottomButton floatingButtonToolbarBlank",
    on: {
      "click": _vm.sendPayments
    }
  }, [_c('i', {
    staticClass: "icon-mail_reply icon icon-float-button"
  })]) : _vm._e(), _vm._v(" "), _c('f7-fab', {
    staticClass: "leftfav button-fab bottomButton floatingButtonToolbarBlank"
  }, [_c('f7-icon', {
    attrs: {
      "f7": "document_text"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "popoverName": ".popoverSendbox",
      "subNavTitle": "Modular Loan - Draft",
      "menuAccess": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row form-group",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "row showLargeScreenOnly rowSearchBar"
  }, [_c('div', {
    staticClass: " firstButtonMarginLeft"
  }, [_c('button', {
    staticClass: "new-button milkyBlock",
    on: {
      "click": _vm.sendAllReadyPayments
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "sort_down_round_fill"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Send completed drafts")])], 1)]), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "new-button milkyBlock rowSearchBar",
    on: {
      "click": _vm.createDraft
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Create new draft")])], 1)]), _vm._v(" "), (_vm.draftsSelected.length > 0) ? _c('div', {}, [_c('button', {
    staticClass: "new-button milkyBlock",
    on: {
      "click": _vm.sendPayments
    }
  }, [_c('i', {
    staticClass: "icon-mail_reply icon icon-float-sub-button"
  }), _vm._v(" "), _c('span', [_vm._v("Reply")])])]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "new-button milkyBlock pull-right",
    on: {
      "click": function($event) {
        return _vm.extractCSV(_vm.drafts)
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "document_text"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Extract CSV")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('f7-searchbar', {
    staticClass: "search",
    attrs: {
      "cancel-link": "Cancel",
      "placeholder": "Search in Drafts",
      "search-list": "#draft-list"
    },
    on: {
      "searchbar:search": _vm.onSearch,
      "searchbar:clear": _vm.onClear
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layoutSubtitle"
  }), _vm._v(" "), _c('cm-draft-list', {
    attrs: {
      "filterBy": _vm.filterBy,
      "drafts": _vm.drafts
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9438e020", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9438e020","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/services/directDebit/DDDraftPage.vue
// module id = 2485
// module chunks = 2